module.exports = __webpack_public_path__ + "static/media/main_02.68697247.png";